"use client";

import ListLayout from "@/app/components/layout/list";
import { BreadCrumb } from "@/app/components/title/index";

import { Suspense } from "react";
import { Spin } from "antd";
import { useState, useEffect, useRef, SetStateAction } from "react";
import clsx from "clsx";
import Image from "next/image";

export type DetailType = {
  documentId: string;
  title: string;
  createdAt: string;
  content: string;
  author: string;
  source: string;
  access_times: number;
  [string: string]: any;
};

type FontSize = "small" | "normal" | "large";

export default function Detail({
  detail,
  download = false,
}: {
  detail: DetailType;
  download?: boolean;
}) {
  const [fontSize, setFontSize] = useState<FontSize>("normal");

  return (
    <div className="relative main-content p-[0]!">
      <BreadCrumb detailPage></BreadCrumb>
      <div>
        <div className="mx-auto min-h-[510px] px-[40px] relative">
          <Suspense fallback={<Spin />}>
            <DetailHeader
              detail={detail}
              setFontSize={setFontSize}
            ></DetailHeader>
            <div className="mt-[20px] pb-[50px]">
              <RichTextRenderer
                fontSize={fontSize}
                content={detail.content}
                className={clsx(`text-justify! leading-[2.1]!`)}
                download={download}
              ></RichTextRenderer>
            </div>
            <div className="border-t-[1px] border-dashed absolute bottom-[10px] w-[1128px] pt-[10px]">
              <div className="flex justify-between">
                <div></div>
                <div className="flex  text-[#999] text-[12px]/[22px] mr-[15px]">
                  <div
                    className="flex items-center cursor-pointer"
                    onClick={() => window.print()}
                  >
                    <div className="h-[16px] w-[16px] bg-[url('/imgs/print.gif')] bg-[left_center] bg-no-repeat "></div>
                    <div className="pl-[8px]">打印本页</div>
                  </div>
                  <div
                    className="flex items-center cursor-pointer ml-[18px]"
                    onClick={() => window.close()}
                  >
                    <div className="h-[16px] w-[16px] bg-[url('/imgs/close.gif')] bg-[left_center] bg-no-repeat "></div>
                    <div className="pl-[8px]">关闭</div>
                  </div>
                </div>
              </div>
            </div>
          </Suspense>
        </div>
      </div>
    </div>
  );
}

export function DetailHeader({
  detail,
  setFontSize,
}: //   setTextConfig,
{
  detail: DetailType;
  setFontSize: React.Dispatch<SetStateAction<FontSize>>;
  //   setTextConfig: React.Dispatch<SetStateAction<string>>;
}) {
  return (
    <div className="">
      <h1 className="text-center pt-[35px] text-[26px]! text-[#333]">
        {detail.title}
      </h1>
      <div className="text-center text-[13px] mt-[35px]">
        {detail.createdAt && (
          <span>
            发布日期：{detail.createdAt?.replace("T", " ").slice(0, 19)}
            &nbsp;&nbsp;
          </span>
        )}
        {detail.author && <span>作者：{detail.author} &nbsp;&nbsp;</span>}
        {detail.source && <span>来源：{detail.source} &nbsp;&nbsp;</span>}
        {<span>阅读：{detail.access_times} 次&nbsp;&nbsp;</span>}
        <span>
          字体：
          <span onClick={() => setFontSize("large")} className="cursor-pointer">
            [大]&nbsp;
          </span>
          <span
            onClick={() => setFontSize("normal")}
            className="cursor-pointer"
          >
            [中]&nbsp;
          </span>
          <span onClick={() => setFontSize("small")} className="cursor-pointer">
            [小]&nbsp;
          </span>
        </span>
      </div>
      <div className="border-b-[1px] mt-[10px] border-solid border-[#dbdee1]"></div>
    </div>
  );
}

export function RichTextRenderer({
  content,
  className = "",
  download,
  fontSize = "normal",
}: {
  content: string;
  className?: string;
  download?: boolean;
  fontSize: FontSize;
}) {
  const richTextRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (download) {
      if (richTextRef.current) {
        const s = new XMLSerializer();
        const links = richTextRef.current.querySelectorAll("a");
        links.forEach((link) => {
          const filename = link.innerHTML.replace(
            /<[^>]+>|&(nbsp|amp|lt|gt|quot|#39);/g,
            ""
          );
          const href = link.getAttribute("href")!;
          const url = new URL(href).pathname;
          link.setAttribute("href", url);
          link.setAttribute("download", filename);
          link.style.color = "#2479FF";
        });
      }
    }
    // 清理事件监听
  }, [richTextRef]);

  const fontSizeConfig = {
    small: "14px",
    normal: "16px",
    large: "18px",
  };

  return (
    <div
      ref={richTextRef}
      className={className}
      dangerouslySetInnerHTML={{
        __html: content.replace(
          /font-size:\s*\d+(\.\d+)?(px|pt|em|%)/gi,
          `font-size: ${fontSizeConfig[fontSize]}`
        ),
      }}
    />
  );
}
